import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_email_list = (page, per_page, name, status) => {
  return api.post(`${ApiEndpointConstants.GETEMAILLIST}`, {
    page,
    per_page,
    name,
    status,
  });
};
